import type { SkillCategory } from '@/types';

/**
 * Skills grouped from the CV personal/job-related skills and role technologies.
 * No proficiency percentages.
 */
export const skillCategories: SkillCategory[] = [
  {
    id: 'backend',
    title: 'Backend',
    description: 'APIs, services, and server-side application logic.',
    skills: [
      'C#',
      '.NET / ASP.NET Core',
      'CQRS',
      'MediatR',
      'REST APIs',
      'SignalR',
      'RabbitMQ',
      'Elasticsearch',
      'Layered Architecture',
      'PHP',
    ],
  },
  {
    id: 'frontend',
    title: 'Frontend',
    description: 'Modern web interfaces and client applications.',
    skills: ['Angular', 'React', 'HTML / CSS', 'JavaScript / TypeScript', 'Responsive Design'],
  },
  {
    id: 'mobile',
    title: 'Mobile',
    description: 'Cross-platform and native mobile delivery.',
    skills: ['Flutter', 'Dart', 'Android (Java / SDK)', 'Swift / SwiftUI', 'iOS', 'Material Design'],
  },
  {
    id: 'databases',
    title: 'Databases',
    description: 'Relational data storage and search.',
    skills: ['SQL / SQL Server', 'MySQL', 'Elasticsearch'],
  },
  {
    id: 'architecture',
    title: 'Architecture & Integration',
    description: 'Patterns used to keep systems maintainable and connected.',
    skills: ['CQRS', 'MediatR', 'Repository Pattern', 'MVP', 'BLoC', 'Provider', 'REST Integration'],
  },
  {
    id: 'devops',
    title: 'DevOps & Tooling',
    description: 'Version control, delivery, and day-to-day engineering tools.',
    skills: [
      'Git',
      'Azure DevOps',
      'Visual Studio',
      'Visual Studio Code',
      'Android Studio',
      'WordPress',
      'cPanel',
    ],
  },
];
